import React from 'react';
import { Text } from '@soluto-design/react';
import CardBase from '../CardBase';
import DataItem from '../../atoms/DataItem';
import Media, { MediaProps } from '../Media';

export interface CardValueProps {
    variant: 'content' | 'image';
    value?: string;
    description?: string;
    image?: MediaProps['media'];
}

export default function CardValue({
    variant,
    value,
    description,
    image,
}: CardValueProps) {
    return (
        <>
            {variant === 'content' && (value || description) && (
                <CardBase className="rounded-large bg-background-secondary p-lg min-h-[158px] md:min-h-[232px] xl:min-h-[266px] flex flex-col gap-48 justify-between">
                    {!!value && <DataItem value={value} />}
                    {!!description && (
                        <Text
                            component="p"
                            className="text-b400 text-text-secondary">
                            {description}
                        </Text>
                    )}
                </CardBase>
            )}
            {variant === 'image' && image && (
                <CardBase className="relative overflow-hidden rounded-large min-h-[158px] md:min-h-[232px] xl:min-h-[266px]">
                    <Media media={image} layout="fill" />
                </CardBase>
            )}
        </>
    );
}
